import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../models/user';

@Component({
	selector: 'app-tracking-progress',
	templateUrl: './tracking-progress.component.html',
	styleUrls: ['./tracking-progress.component.scss']
})
export class TrackingProgressComponent implements OnInit {
	@Input() public stop: any;
	@Input() public user: User;

	constructor() {
	}

	ngOnInit() {
	}

}
